import IRepresentativeRepository from 'domain/interfaces/repositories/IAuthUserRepository'

export const recoverPasswordRepresentativeCommand = (
  repository: IRepresentativeRepository,
  identificationNumber: string,
) => {
  return repository.recoverPassword(identificationNumber)
}
